<template>
  <h6 class="margin-bottom-xxs">
    Your free swatches are on the way!
  </h6>
  <span>You'll receive them in 7-10 business days.</span>
</template>
